(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  class SzyaArticle extends HTMLElement {
    constructor() {
      super();

      this.initHero();
      this.initArticleContent();
    }

    initHero() {
      const img = this.querySelector('.article__hero-image img');
      if (!img) return;

      const check = () => {
        if (img.naturalHeight > img.naturalWidth) {
          img.closest('.article__hero-image').classList.add('article__hero-image--portrait');
        }
      };

      if (img.complete) {
        check();
      } else {
        img.addEventListener('load', check, { once: true });
      }
    }

    initArticleContent() {
      // Add classes to paragraphs based on their content
      this.querySelectorAll('.article__content > p, .article__content > div, .article__content > h3').forEach((el) => {
        if (el.querySelectorAll('img').length > 1) {
          el.classList.add('article__diptych-paragraph');
        } else if (el.querySelector('img')) {
          el.classList.add('article__image-paragraph');
        } else {
          el.classList.add('article__text-paragraph');
        }
      });

      // Group text paragraphs under their preceding h2
      this.querySelectorAll('.article__content > h2').forEach((h2) => {
        if (h2.nextElementSibling && h2.nextElementSibling.classList.contains('article__text-paragraph')) {
          let newDiv = document.createElement('div');

          newDiv.classList.add('article__text-group');
          h2.parentNode.insertBefore(newDiv, h2);
          newDiv.appendChild(h2);

          let next = newDiv.parentNode.children[Array.from(newDiv.parentNode.children).indexOf(newDiv) + 1];
          while (next && next.classList.contains('article__text-paragraph')) {
            let following = next.nextElementSibling;
            newDiv.appendChild(next);
            next = following;
          }
        }
      });

      this.querySelectorAll('.article__content img').forEach((img) => {
        // Add caption to images with alt text
        if (img.alt) {
          let figure = document.createElement('figure');
          let caption = document.createElement('figcaption');

          figure.classList.add('article__image-figure');
          img.parentNode.insertBefore(figure, img);
          figure.appendChild(img);
          caption.classList.add('article__image-caption');
          caption.textContent = img.alt;
          figure.appendChild(caption);
        }

        if (img.parentElement.classList.contains('article__image-paragraph')) {
          const check = () => {
            if (img.naturalHeight > img.naturalWidth) {
              img.closest('.article__image-paragraph').classList.add('article__image-paragraph--portrait');
            }
          };

          if (img.complete) {
            check();
          } else {
            img.addEventListener('load', check, { once: true });
          }
        }
      });
    }
  }

  customElements.define('szya-article', SzyaArticle);

  } catch(e) { console.error(e); }
})();
})();
